import { selectApp } from "./selectApp";

export const selectCurrentStep = state => selectApp(state).step;
